var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-638.728,-947.739)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,8,51.8415)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.373677,0,0,0.373677,431.479,561.389)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,156.349,-30.4167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382,931L389.263,938.263L396.792,930.734",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "5.7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,156.349,-17.4167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382,931L389.263,938.263L396.792,930.734",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "5.7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,156.349,-4.41667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382,931L389.263,938.263L396.792,930.734",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "5.7px"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.dbb48c4f7f501c2593283ed639a33682.svg";
export { ForwardRef as ReactComponent };